import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';

export const PROCESS_PAYMENT_ENDPOINT = '/Adviser/Subscription/ProcessPaymentInfo';

const processPayment = tokenId => {
  return authFetch(PROCESS_PAYMENT_ENDPOINT, {
    method: 'POST',
    ...httpBodyOptions({ tokenId }),
  });
};

export const useProcessPaymentMutation = () => useMutation(processPayment);
